/* ALGOLIA */
export const INIT_ALGOLIA_INDEX = "INIT_ALGOLIA_INDEX";
export const SEARCH_ALGOLIA_STORE = "SEARCH_ALGOLIA_STORE";

export const CREATE_PURCHASE = "CREATE_PURCHASE";

export const FETCH_DOWNLOAD_URL = "FETCH_DOWNLOAD_URL";
export const FETCH_PAYMENT = "FETCH_PAYMENT";
export const SET_PAYMENT = "SET_PAYMENT";
export const VERIFY_TOKEN = "VERIFY_TOKEN";
export const FETCH_NAIC_CODES = "FETCH_NAIC_CODES";
export const SET_NAIC_CODES = "SET_NAIC_CODES";
export const FETCH_INSURANCE_RECEIPT_DOWNLOAD_URL = "FETCH_INSURANCE_RECEIPT_DOWNLOAD_URL";

export const FETCH_AUTH_USER = "FETCH_AUTH_USER";
export const AUTH_LOGIN = "AUTH_LOGIN";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const SET_AUTH_USER = "SET_AUTH_USER";
export const LOGOUT = "LOGOUT";
export const AUTH_RESET_PASSWORD = "AUTH_RESET_PASSWORD";
export const VERIFY_RESET_TOKEN = "VERIFY_RESET_TOKEN";
export const RESET_PASSWORD = "RESET_PASSWORD";

export const FETCH_UNDERWRITINGS = "FETCH_UNDERWRITINGS";
export const SET_UNDERWRITINGS = "SET_UNDERWRITINGS";
export const DOWNLOAD_RECEIPT = "DOWNLOAD_RECEIPT";
export const UPDATE_UNDERWRITING = "UPDATE_UNDERWRITING";
export const SET_UPDATE_UNDERWRITING = "SET_UPDATE_UNDERWRITING";
export const UPDATE_PAYMENT = "UPDATE_PAYMENT";
export const SET_UPDATE_PAYMENT = "SET_UPDATE_PAYMENT";

export const SEND_MESSAGE = "SEND_MESSAGE";
export const SET_NAV_HEIGHT = "SET_NAV_HEIGHT";

